import { useTranslation } from 'react-i18next';

import { LabelValuePair } from 'theSource/components';
import {
  BeneficiaryContainerStyled,
  AllocationLabelStyled,
  NarrowBoxStyled,
  WiderBoxStyled,
} from './BeneficiaryContainerStyled';

export interface BeneficiaryContainerProps {
  relationship: string;
  name: string;
  allocation: string;
  testId?: string;
}

export const BeneficiaryContainer = ({
  name,
  relationship,
  allocation,
  testId = 'beneficiary',
}: BeneficiaryContainerProps) => {
  const { t } = useTranslation('pages.benefits');

  return (
    <BeneficiaryContainerStyled data-testid={testId}>
      <WiderBoxStyled>
        <LabelValuePair
          label={relationship}
          value={name}
          valueHolderVariant="body2"
        />
      </WiderBoxStyled>
      <NarrowBoxStyled>
        <AllocationLabelStyled variant="label">
          {t('allocation')}: {parseFloat(allocation)}%
        </AllocationLabelStyled>
      </NarrowBoxStyled>
    </BeneficiaryContainerStyled>
  );
};
